import React from 'react';
import { EditBlackIcon, FolderIcon } from '@components/icons/svg-icon.tsx';
import { Checkbox, ListItemIcon } from '@mui/material';
import { FolderItemProps } from '@models/media-library.model.ts';

const FolderItem: React.FC<FolderItemProps> = ({
  data,
  checked,
  disabled,
  onCheckedChange,
  onFolderClick,
  onEditClick
}) => {
  return (
    <div
      onDoubleClick={() => onFolderClick(data)}
      className={`min-w-[278px] relative p-3 cursor-pointer border border-[rgba(223,234,242,1)] rounded-[10px] transition-colors duration-300 group max-lg-xl:p-2 max-lg-xl:min-w-[240px]
      ${checked ? 'bg-[var(--gray-11)]' : 'bg-white hover:bg-[var(--gray-11)]'}`}
    >
      <div
        className={`absolute left-[2px] top-[2px] transition-opacity duration-300
          ${checked ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto'}`}
      >
        <Checkbox
          disabled={disabled}
          className="primary-checkbox"
          sx={{
            '& .MuiSvgIcon-root': {
              height: 20,
              width: 20
            }
          }}
          checked={checked}
          onChange={(e) => onCheckedChange(e.target.checked)}
        />
      </div>

      <div
        className={`absolute right-1.5 bottom-1.5 transition-opacity duration-300 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto`}
      >
        <ListItemIcon
          className="!min-w-[30px] cursor-pointer !h-[30px] !bg-white rounded-full flex items-center justify-center"
          onClick={() => onEditClick(data)}
        >
          <EditBlackIcon className="!w-[17px] !h-[17px]" />
        </ListItemIcon>
      </div>

      <div className="flex w-full items-center gap-5">
        <div
          className={`flex justify-center items-center rounded-[8px] py-3 px-2.5
            bg-[var(--gray-11)] group-hover:bg-transparent transition-colors duration-300 max-lg-xl:py-1.5 max-lg-xl:px-1.5
            ${checked ? 'bg-transparent' : ''}`}
        >
          <FolderIcon className="!w-[34px] !h-[34px] max-lg-xl:!w-[32px] max-lg-xl:!h-[32px]" />
        </div>

        <div className="flex flex-col gap-1 max-lg-xl:gap-0.5">
          <p className="text-base text-[rgba(25,27,27,0.60)] font-medium max-lg-xl:text-[14px]">
            {data.title}
          </p>
          <div className="flex items-center gap-1">
            <p className="text-[13px] text-[rgba(113,142,191,1)] opacity-50 font-normal max-lg-xl:text-[12px]">
              {data.folderCount} folders
            </p>
            <p className="text-[13px] text-[rgba(113,142,191,1)] opacity-50 font-normal max-lg-xl:text-[12px]">
              {data.assetsCount} assets
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FolderItem;
